import React from "react";
import { InMemoryDownload } from "../InMemoryDownload";
import { Release } from "../../models";
import { ReleaseFileList } from "./ReleaseFileList";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function BundleFileList({ releaseFiles, release }: Props) {
  return (
    <>
      <td colSpan={3}>
        {releaseFiles.bundleJson && (
          <InMemoryDownload
            displayName="Manifest"
            fileName={`bundle_manifest.${release.version}.json`}
            content={releaseFiles.bundleJson?.data}
          />
        )}
      </td>
    </>
  );
}
